export const awsBaseUrl = process.env.REACT_APP_AWS_BUCKET_BASE_URL;

export const PRELIMINARY_MAX_TIME_OPTIONS = [10, 20, 30, 45];

export const getOptionText = (option) => {
  if (option == null) return "";
  if (typeof option === "string" || typeof option === "number") return String(option);
  if (typeof option === "object") {
    return option?.option ?? option?.title ?? option?.name ?? "";
  }
  return String(option);
};

export const getQuestionTypeId = (questionType) => {
  if (questionType == null) return "";
  if (typeof questionType === "object") return questionType?._id ?? "";
  return questionType;
};

export const getGroupTypeId = (groupType) => {
  if (groupType == null) return "";
  if (typeof groupType === "object") return groupType?._id ?? "";
  return groupType;
};

export const getGroupTypeLabel = (groupType, groupTypeList) => {
  const id = getGroupTypeId(groupType);
  const match = groupTypeList?.find((t) => t?._id === id);
  if (match) return match?.type_en || match?.type || "";
  if (typeof groupType === "object") {
    return groupType?.type_en || groupType?.type || "";
  }
  return groupType || "";
};

export const isValidPhoneNumber = (phone) => {
  if (!phone || typeof phone !== "string") return false;
  const cleaned = phone.trim();
  return /^\+?[0-9]{8,15}$/.test(cleaned);
};

export const formatPaidAmount = (amount) => {
  if (amount == null || amount === "" || Number.isNaN(Number(amount))) {
    return "";
  }
  return `${amount} €`;
};

export const isEmptyHtmlContent = (html) => {
  if (!html) return true;
  const text = html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
  return text.length === 0;
};
